import React, { PureComponent } from 'react';
import { GlobalHeader } from '@eb/eds-global-header';
import {
    getLogoInfo,
    getNonUserQuickLinks,
    getUserMenuInfo,
} from '@eb/site-header';
import {
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
} from '@eb/site-structure';
import { gettext } from '@eb/i18n';
import { EventbriteAppMarketplaceLogo } from '../../svgs/index';

const logoOptions = {
    iconType: <EventbriteAppMarketplaceLogo />,
    iconWidth: '260px',
    iconHeight: '23px',
    iconColor: 'background-rgb',
};
export default class CustomGlobalHeader extends PureComponent {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
    };

    _getQuickLinks(env, user) {
        const quickLinks = [];

        if (user.isAuthenticated) {
            quickLinks.push({
                url: `${env.serverUrl}/organizations/extensions/`,
                content: (
                    <span className="eds-text-weight--heavy">
                        {gettext('Manage apps')}
                    </span>
                ),
            });
        }

        return quickLinks;
    }

    render() {
        const { env, request, user } = this.props;

        const userMenuInfo = {
            serverUrl: env.serverUrl,
            adminServerUrl: env.adminServerUrl,
            logoutUrl: env.logoutUrl,
            requestPath: request.path,
            user,
            isNewAccountSettingsActive: user.isNewAccountSettingsActive,
            showBrowseEvents: false,
        };

        const logoInfo = getLogoInfo(env.serverUrl, request.path, {
            ...logoOptions,
            url: `${env.serverUrl}/apps/`,
        });

        return (
            <GlobalHeader
                logoInfo={logoInfo}
                userMenuInfo={getUserMenuInfo(userMenuInfo)}
                quickLinks={this._getQuickLinks(env, user)}
                nonUserQuickLinks={getNonUserQuickLinks(
                    request.path,
                    user.isAuthenticated,
                    env.loginUrl,
                )}
            />
        );
    }
}
